<mat-card appearance="outlined">
  <mat-card-header>
    <mat-icon mat-card-avatar class="google"></mat-icon>
    <mat-card-title>
      {{ 'INBOX.SETTINGS.GOOGLE_BUSINESS_MESSAGES.TITLE' | translate }}

      <glxy-badge [color]="badgeColor()" *ngIf="!loading() && !isNativeApp">
        {{ (googleBusinessMessagesEnabled() ? 'INBOX.SETTINGS.ACTIVE' : 'INBOX.SETTINGS.INACTIVE') | translate }}
      </glxy-badge>
    </mat-card-title>
  </mat-card-header>
  <div *ngIf="loading() && !isNativeApp" class="loading-state">
    <mat-spinner class="spinner" diameter="40"></mat-spinner>
  </div>
  <mat-card-content *ngIf="!loading() || isNativeApp">
    <p>
      <strong>
        {{ 'INBOX.SETTINGS.GOOGLE_BUSINESS_MESSAGES.DESCRIPTION' | translate }}
      </strong>
    </p>
    <ng-container *ngIf="!isNativeApp; else manageOnWeb">
      <p *ngIf="cardDescription() !== ''">
        {{ cardDescription() | translate }}
      </p>

      <p *ngIf="showAlert() !== 'gbp-not-connected' && businessInfo()?.name">
        {{ 'INBOX.SETTINGS.GOOGLE_BUSINESS_MESSAGES.BUSINESS_NAME' | translate }}:
        <strong *ngIf="businessInfo()?.mapsUri">
          <a [href]="businessInfo()?.mapsUri" target="_blank" rel="noopener noreferrer">{{ businessInfo()?.name }}</a>
        </strong>
        <strong *ngIf="!businessInfo()?.mapsUri">
          {{ businessInfo()?.name }}
        </strong>
      </p>

      <ng-container [ngSwitch]="showAlert()">
        <ng-container *ngSwitchCase="'gbp-not-connected'" [ngTemplateOutlet]="noConnectedAccount"></ng-container>
        <ng-container
          *ngSwitchCase="'gbp-not-verified'"
          [ngTemplateOutlet]="connectedAccountNotVerified"
        ></ng-container>
        <ng-container *ngSwitchCase="'auth-insufficient'" [ngTemplateOutlet]="authError"></ng-container>
        <ng-container *ngSwitchCase="'setup-blocked'"></ng-container>
        <ng-container *ngSwitchCase="'no-alert'">
          <ng-container [ngSwitch]="googleBusinessMessagesEnabled()">
            <ng-container *ngSwitchCase="false" [ngTemplateOutlet]="connectButton"></ng-container>
            <ng-container *ngSwitchCase="true" [ngTemplateOutlet]="disconnectButton"></ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="actionErrors() !== null" [ngTemplateOutlet]="actionError"></ng-container>

      <p class="disclaimer" *ngIf="businessInfo()">
        {{ 'INBOX.SETTINGS.GOOGLE_BUSINESS_MESSAGES.DISCLAIMER' | translate }}
      </p>
    </ng-container>
  </mat-card-content>
</mat-card>

<!-- account connected but with insufficient permissions -->
<ng-template #authError>
  <glxy-alert
    class="auth-alert"
    type="error"
    [showAction]="true"
    actionTitle="{{ 'INBOX.SETTINGS.GOOGLE_BUSINESS_MESSAGES.RECONNECT' | translate }}"
    (actionClick)="reauthorize()"
    [extendedBorder]="true"
  >
    <p>
      <strong>{{ 'INBOX.SETTINGS.GOOGLE_BUSINESS_MESSAGES.RECONNECT_GBP' | translate }}</strong>
      <br />
      {{ 'INBOX.SETTINGS.GOOGLE_BUSINESS_MESSAGES.RECONNECT_GBP_DETAIL' | translate }}
    </p>
  </glxy-alert>
</ng-template>

<!-- google business profile not connected -->
<ng-template #noConnectedAccount>
  <ng-template [ngTemplateOutlet]="connectGoogleBusinessProfileButton" />
</ng-template>

<!-- google business profile not verified by google -->
<ng-template #connectedAccountNotVerified>
  <glxy-alert
    class="auth-alert"
    type="error"
    [showAction]="true"
    actionTitle="{{ 'INBOX.SETTINGS.GOOGLE_BUSINESS_MESSAGES.AUTHORIZE' | translate }}"
    (actionClick)="reauthorize()"
  >
    <p>
      <strong>
        {{ 'INBOX.SETTINGS.GOOGLE_BUSINESS_MESSAGES.PROBLEM_WITH_CONNECTION' | translate }}
      </strong>
      <br />
      <span
        [innerHTML]="
          'INBOX.SETTINGS.GOOGLE_BUSINESS_MESSAGES.GOOGLE_PROFILE_ERROR'
            | translate: { businessName: businessInfo()?.name ?? 'hello' }
        "
      ></span>
    </p>
  </glxy-alert>
</ng-template>

<ng-template #actionError>
  <glxy-alert class="auth-alert" type="error" [extendedBorder]="true">
    <strong>
      {{ actionErrors()?.title || '' | translate }}
    </strong>
    <glxy-alert-extended>
      <div [innerHTML]="actionErrors()?.description || '' | translate: { accountId: (accountGroupId$ | async) }"></div>
    </glxy-alert-extended>
  </glxy-alert>
</ng-template>

<ng-template #connectButton>
  <p class="actions">
    <button
      type="button"
      mat-flat-button
      color="primary"
      [disabled]="loading() || showAlert() !== 'no-alert' || !canEnable()"
      (click)="connectGoogleBusinessCommunications()"
    >
      <span *ngIf="!loading()">{{ 'INBOX.SETTINGS.GOOGLE_BUSINESS_MESSAGES.CONNECT' | translate }}</span>
    </button>
  </p>
</ng-template>

<ng-template #connectGoogleBusinessProfileButton>
  <p *ngIf="!loading()">{{ 'INBOX.SETTINGS.GOOGLE_BUSINESS_MESSAGES.GOOGLE_PROFILE_ERROR' | translate }}</p>

  <p class="actions">
    <button type="button" mat-flat-button color="primary" (click)="reauthorize()">
      <span *ngIf="!loading()">{{ 'INBOX.SETTINGS.GOOGLE_BUSINESS_MESSAGES.AUTHORIZE' | translate }}</span>
    </button>
  </p>
</ng-template>

<ng-template #disconnectButton>
  <p class="actions">
    <button
      type="button"
      mat-stroked-button
      (click)="disconnectPopover.open()"
      [glxyPopover]="disconnectPopover"
      [disabled]="loading()"
    >
      <span *ngIf="!loading()">{{ 'INBOX.SETTINGS.GOOGLE_BUSINESS_MESSAGES.DISCONNECT' | translate }}</span>
    </button>
  </p>
  <glxy-popover #disconnectPopover padding="small" [closeOnBackdropClick]="true" [closeOnEscapeKey]="true">
    <glxy-popover-title>
      {{ 'INBOX.SETTINGS.GOOGLE_BUSINESS_MESSAGES.CONFIRM_DISCONNECT_TITLE' | translate }}
    </glxy-popover-title>
    <div [innerHTML]="'INBOX.SETTINGS.GOOGLE_BUSINESS_MESSAGES.CONFIRM_DISCONNECT_DESCRIPTION' | translate"></div>
    <glxy-popover-actions>
      <button type="button" mat-stroked-button (click)="disconnectPopover.close()">
        {{ 'INBOX.CANCEL' | translate }}
      </button>
      <button
        type="button"
        mat-stroked-button
        color="warn"
        class="disconnect-button"
        (click)="unlaunchGoogleBusinessCommunications(); disconnectPopover.close()"
      >
        {{ 'INBOX.SETTINGS.GOOGLE_BUSINESS_MESSAGES.DISCONNECT' | translate }}
      </button>
    </glxy-popover-actions>
  </glxy-popover>
</ng-template>

<ng-template #manageOnWeb>
  <inbox-manage-on-web></inbox-manage-on-web>
</ng-template>
